export enum FixedPhraseTextKinds {
  Text = 1,
  Tag = 2
}
